export default "/dist/files/choix_animation_boite_idees.c34b844e699eaece9947c4f2e04f4a5b.svg";